import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/slide-left-right.svg'


const _hoisted_1 = { class: "slide-content-table" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

import { useLocalization } from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'slide-content-table',
  setup(__props) {

const { t, dict } = useLocalization();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", null, _toDisplayString(_unref(t)(_unref(dict).COMMON.SLIDE_TABLE_TO_VIEW_CONTENT)), 1)
  ]))
}
}

})